import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3000";

const config = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
});

export interface IEmailLog {
    _id: string;
    ownerId: string;
    to: string;
    toName?: string;
    subject: string;
    template?: string;
    variables?: Record<string, any>;
    html?: string;
    text?: string;
    status: 'sent' | 'failed' | 'pending';
    messageId?: string;
    error?: string;
    sentAt?: Date;
    createdAt: Date;
    updatedAt: Date;
}

export interface SendEmailParams {
    to: string;
    toName?: string;
    subject: string;
    template?: string;
    variables?: Record<string, any>;
    html?: string;
    text?: string;
}

export interface EmailStats {
    total: number;
    sent: number;
    failed: number;
    pending: number;
    recentEmails: IEmailLog[];
    period: string;
}

// Send an email (admin only)
export const sendEmail = async (params: SendEmailParams) => {
    const response = await axios.post(`${API_BASE}/emails/send`, params, config());
    return response.data;
};

// Get all email logs (admin only)
export const getEmailLogs = async (filters?: { 
    page?: number; 
    limit?: number; 
    status?: 'sent' | 'failed' | 'pending';
}) => {
    const searchParams = new URLSearchParams();
    
    if (filters?.page) searchParams.append("page", String(filters.page));
    if (filters?.limit) searchParams.append("limit", String(filters.limit));
    if (filters?.status) searchParams.append("status", filters.status);
    
    const url = `${API_BASE}/emails${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
    const response = await axios.get(url, config());
    return response.data;
};

// Get email statistics (admin only)
export const getEmailStats = async (days: number = 30): Promise<{ data: EmailStats }> => {
    const response = await axios.get(`${API_BASE}/emails/stats?days=${days}`, config());
    return response.data;
};

// Get a specific email log (admin only)
export const getEmailLog = async (id: string): Promise<{ data: IEmailLog }> => {
    const response = await axios.get(`${API_BASE}/emails/${id}`, config());
    return response.data;
};
